import React from 'react';
import Projects from './projects';
import Writings from './writings';
import Location from './location';
import MISC from './misc';

const Home = () => {
  return (
    <>
      <section className="App-intro">
        <h5>Howdy <span className="wave">👋</span></h5>
        <p>Thanks for visiting my website!</p>
        <p>I graduated from Texas A&M University in 2023 with a concentration in Computer Science and I currently work at Microsoft!</p>
        <p>
        Pre-college, I explored various mediums of creation like music production, podcasts, and video editing. After reading a book explaining code as a form of permissionless leverage, I built my first website which reached over 200k users and I've been coding ever since.
        </p>
        <p>
        I've also solo skydived over 10 times, summited 2 mountains and completed an Ironman 70.3.
        </p>
        <p>
        In my free time I love hooping, reading about history and human biology, and playing both ping-pong & pool!
        </p>
      </section>

      <Location />
      <Projects />
      <Writings />
      <MISC />
    </>
  );
};

export default Home;


